import { render, staticRenderFns } from "./WorkspaceReadyModal.vue?vue&type=template&id=55ec1ed3&"
import script from "./WorkspaceReadyModal.vue?vue&type=script&lang=js&"
export * from "./WorkspaceReadyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports